{
  "title": "Zephyr Strike",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "1st-level transmutation",
  "level": 1,
  "castingTime": "1 bonus action",
  "range": "Self",
  "components": "V",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You move like the wind. For the duration, your movement doesn’t provoke opportunity attacks.",
    "Once before the spell ends, you can give yourself advantage on one weapon attack roll on your turn. That attack deals an extra 1d8 force damage on a hit. Whether you hit or miss, your walking speed increases by 30 feet until the end of that turn."
  ],
  "spellLists": ["ranger"]
}
